import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  markdownDescription: {
    fontSize: theme.typography.caption.fontSize,
    margin: 0,
    color: theme.palette.text.secondary,
    '& :first-child': {
      margin: 0,
      marginTop: '3px',
    },
  },
  formHeaderContainer: {
    marginBottom: theme.spacing(2),
  },
  formPaperContainer: {
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  formPaper: {
    elevation: theme.spacing(2),
  },
  formPaperChildContainer: {
    padding: theme.spacing(2),
  },
  flexContainer: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  infoDocOpenButton: {
    cursor: 'pointer',
    marginLeft: theme.spacing(2),
  },
  infoDocDivider: {
    marginRight: theme.spacing(0),
  },
  infoDocCloseButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
  infoDocContent: {
    fontSize: theme.typography.subtitle1.fontSize,
    '& p': {
      fontSize: theme.typography.subtitle1.fontSize,
    },
  },
  infoDocDrawerContainer: {
    width: 480,
    maxWidth: '90vw',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  infoDocDrawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2, 2, 1, 2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  infoDocDrawerContent: {
    flex: 1,
    overflowY: 'auto',
    padding: theme.spacing(2),
  },
}));
